import { ApiProperty } from '@nestjs/swagger';

/**
 * DTO para combos de filtros en Control DUS.
 * Retorna valores únicos para poblar dropdowns.
 *
 * ✅ IMPORTANTE - Formato Estándar:
 * - VesselComboDto: Formato estándar { vesselId, vesselName } (consistente con Commons)
 * - EtapaComboDto: Específico de Control DUS { etapa, count }
 * - EstadoComboDto: Específico de Control DUS { estado, count }
 *
 * Los combos de Etapa y Estado incluyen conteo porque son campos calculados
 * sin ID numérico en la base de datos, útil para mostrar en el UI.
 */

export class VesselComboDto {
  @ApiProperty({
    description: 'ID de la nave',
    example: 5034,
  })
  vesselId!: number;

  @ApiProperty({
    description: 'Nombre de la nave',
    example: 'MSC SANTA MARIA',
  })
  vesselName!: string;
}

export class EtapaComboDto {
  @ApiProperty({
    description: 'Nombre de la etapa',
    example: 'Documentación',
    enum: ['Inicial', 'Documentación', 'Legalización'],
  })
  etapa!: string;

  @ApiProperty({
    description: 'Cantidad de DUS en esta etapa',
    example: 150,
  })
  count?: number;
}

export class EstadoComboDto {
  @ApiProperty({
    description: 'Estado del DUS',
    example: 'Pendiente',
    enum: ['Pendiente', 'En Proceso', 'Finalizado'],
  })
  estado!: string;

  @ApiProperty({
    description: 'Cantidad de DUS en este estado',
    example: 89,
  })
  count?: number;
}

/**
 * DTO para respuesta de combos con metadata adicional.
 */
export class CombosResponseDto<T> {
  @ApiProperty({
    description: 'Lista de opciones del combo',
    type: 'array',
  })
  data!: T[];

  @ApiProperty({
    description: 'Total de opciones disponibles',
    example: 25,
  })
  total!: number;

  @ApiProperty({
    description: 'Timestamp de la respuesta',
    example: '2025-01-24T12:00:00.000Z',
  })
  timestamp!: string;
}
